export const PLANS: Record<string, string> = {
  simple: "Base",
  value: "Crest",
  choice: "Summit",
};

export type PlanId = "simple" | "value" | "choice";

export type QuoteInfo = {
  event_id: string;
  first_name: string;
  for_self: boolean;
  full_name: string;
  insured_dob: string;
  insured_full_name: string;
  hq1: boolean;
  phone: string;
  zip: string;
  plan: PlanId;
  email: string;
};
